import React, { useContext, useEffect, useRef } from 'react';

import { DragDropContext } from './DragDropProvider';

const Draggable = ({ children, draggableId }) => {
    const {
        isDragging, setIsDragging,
        draggingItemId, setDraggingItemId,
        setStartingDroppableId,
        setInitialMousePosition,
        setStartingIndex,
        setHoveringDroppableId
    } = useContext(DragDropContext);

    const ref = useRef();

    const provided = {
        innerRef: ref,
        draggableProps: {
            'data-draggable-id': draggableId,
            onMouseDown: (e) => {
                e.stopPropagation();

                setInitialMousePosition({ x: e.clientX, y: e.clientY });

                setDraggingItemId(draggableId);

                // Get index of current item in parent
                const siblings = Array.from(ref.current.parentNode.children).filter(el => {
                    // if el isn't data-drop-indicator="true"
                    return !el.getAttribute('data-drop-indicator')
                });
                const currentIndex = siblings.indexOf(ref.current);
                setStartingIndex(currentIndex);
                
                // Get closest droppable to element
                const droppable = ref.current.closest("[data-droppable-id]");
                setStartingDroppableId(droppable.getAttribute("data-droppable-id"));
                setHoveringDroppableId(droppable.getAttribute("data-droppable-id"));

                ref.current.style.opacity = '0.5';

                setIsDragging(true);
            },
            // onTouchStart: handleMouseDown,
            style: {
                // cursor: draggingItemId === draggableId && isDragging ? 'grabbing' : 'grab',
                cursor: 'grab',
                // touchAction: draggingItemId === draggableId && isDragging ? 'none' : 'auto',
                // transition: 'width 0.2s ease-in-out',
            }
        }
    };
    const snapshot = {
        isDragging: draggingItemId === draggableId && isDragging,
        // draggingOverValidSection:  draggingItemId === draggableId && isDragging ? true : false,
        // hoveringDroppableId:  isDragging && hoveringDroppableId,
    }

    // console.log("Render draggable");

    return children(provided, snapshot);
};

export default Draggable;